import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, Input, ChangeDetectorRef, AfterViewInit, DoCheck } from '@angular/core';
import moment from 'moment-hijri';
import { ComponentVisibilityService } from 'src/app/services/commonService/component-visibility.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { NgIf, NgFor, NgClass, UpperCasePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-expiry-date',
    templateUrl: './expiry-date.component.html',
    styleUrls: ['./expiry-date.component.scss'],
    imports: [NgIf, MatIcon, NgFor, NgClass, MatButton, UpperCasePipe]
})
export class ExpiryDateComponent implements OnInit, AfterViewInit, DoCheck {
  isHijri: boolean = false;
  startYear: any = null;
  rangeStep = 24;
  currentRangeStart: number = this.startYear;
  years: Array<{
    disabled: any; gregorian: number; hijri: number
  }> = [];
  months: Array<{
    disabled: any; gregorian: string; hijri: string
  }> = [];
  currentMonth: number | undefined;
  currentYear: number | undefined;
  selectedYear: number = 0;
  selectedHijriYear: any;
  selectedHijriMonth: any
  selectedMonth: string | any | null = null;
  selectedDay: number | null = null;
  allowedYearFlag: any;
  showMonths = false;
  showCalendar = false;
  isNextRange: boolean = false
  yearDisable: boolean = false
  maxYearRange: any
  selectedDate: any
  PSQData: any
  parsedData: any
  departureDate: any
  @Input() PassengerTypeCode: string = '';
  @Output() dateSelected = new EventEmitter<{ type: string, date: Date }>();
  @Input() passengerTravelerCode: any
  @Input() infantTravelerCode: any
  @Input() instanceId: string = '';
  @Input() openSelectedDate: any
  @Input() filledDate: any;
  @Input() key: string = "";
  @Input() bypassDate: boolean = false
  minDate: any = {
    year: null,
    month: null,
    date: null
  }
  maxDate: any = {
    year: null,
    month: null,
    date: null
  }
  commonObj: any = {
    headPrevDisabled: false,
    headNextDisabled: false,
  }
  fetchSelectedDate: any[] = []
  selectedMonthIndex: number = 0;
  autoGeneratedDays: any[] = [];
  top: number = 0;
  constructor(private visibilityService: ComponentVisibilityService, private elementRef: ElementRef,
    private cdr: ChangeDetectorRef, private _CommonService: CommonService
  ) { }
  ngDoCheck(): void {
    this.updateTopPosition();
  }
  ngAfterViewInit() {
    this.updateTopPosition();
  }
  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event): void {
    this.updateTopPosition();
  }

  updateTopPosition(): void {
    let calendarPopup = (document.querySelector('.calendar-popup') as HTMLDivElement)?.getBoundingClientRect();
    let calendarParent = this.elementRef.nativeElement.parentNode?.getBoundingClientRect();
    if (calendarParent?.top + (calendarPopup?.height + 60) > this._CommonService.WINDOW_SIZE.height) {
      this.top = (calendarParent.top - 20) - calendarPopup.height;
    } else {
      this.top = calendarParent?.top + 60;
    }
    this.cdr.detectChanges();
  }
  ngOnInit() {
    if (!this.filledDate) {
      this.filledDate = '';
    }
    this.fetchSelectedDate = (this.filledDate as any).split("/");
    this.selectedMonthIndex = this.gregorianMonths.findIndex(($: string, $i: number) => $i == this.fetchSelectedDate[1] - 1) + 1;
    this.selectedDate = (this.filledDate as any).split("/")[0];
    this.selectedYear = (this.filledDate as any).split("/")[2];
    // this.fetchSelectedDateCustom = (this.filledDate as any).split("/")
    moment.locale('en');
    this.currentMonth = moment().month();
    this.currentYear = moment().year();

    if (!this.bypassDate) {

      this.PSQData = sessionStorage.getItem('psq') as string;
      this.parsedData = JSON.parse(this.PSQData);
    }
    if (this.parsedData) {
      if (this.parsedData.masterdetails.searchmode == 'MCT') {
        const itineraries = this.parsedData.trip.itineraries;
        const lastDepartureDateTime = new Date(itineraries[itineraries.length - 1].departureDateTime);
        lastDepartureDateTime.setMonth(lastDepartureDateTime.getMonth() + 6);
        this.departureDate = lastDepartureDateTime.toISOString();
      }
      else if (this.parsedData.masterdetails.searchmode == 'RT') {
        const departureDateTime = new Date(this.parsedData.trip.airBoundsSearchInputs.itineraries[1].departureDateTime);
        departureDateTime.setMonth(departureDateTime.getMonth() + 6);
        this.departureDate = departureDateTime.toISOString();
      }
      else if (this.parsedData.masterdetails.searchmode == 'OW') {
        const departureDateTime = new Date(this.parsedData.trip.airBoundsSearchInputs.itineraries[0].departureDateTime);
        departureDateTime.setMonth(departureDateTime.getMonth() + 6);
        this.departureDate = departureDateTime.toISOString();
      }
    } else {
      if (this.bypassDate) {
        const departureDateTime = new Date();
        departureDateTime.setFullYear(departureDateTime.getFullYear() - 10);
        this.departureDate = departureDateTime.toISOString();
      }
      else {
        const departureDateTime = new Date();
        departureDateTime.setFullYear(departureDateTime.getFullYear());
        departureDateTime.setMonth(departureDateTime.getMonth());
        this.departureDate = departureDateTime.toISOString();
        
      }

    }

    // this.generateMonthNames(); 
    this.generateYearRange();
    this.initializeCalendar();
  }

  initializeCalendar(): void {
    let filledDateMoment: moment.Moment | null = null;
    if (this.filledDate) {
      filledDateMoment = moment(this.filledDate, 'DD/MM/YYYY'); // Parse filledDate

      if (!filledDateMoment.isValid()) {
        console.error('Invalid filledDate format. Expected DD/MM/YYYY.');
        filledDateMoment = null;
      } else if (
        filledDateMoment.isBefore(moment(`${this.minDate.year}-${this.minDate.month + 1}-${this.minDate.date}`, 'YYYY-MM-DD')) ||
        filledDateMoment.isAfter(moment(`${this.maxDate.year}-${this.maxDate.month + 1}-${this.maxDate.date}`, 'YYYY-MM-DD'))
      ) {
        console.error('filledDate is out of the allowed range.');
        filledDateMoment = null;
      }
    }


    const startingDate = filledDateMoment
      ? filledDateMoment
      : moment(`${this.minDate.year}-${this.minDate.month + 1}-${this.minDate.date}`, 'YYYY-MM-DD');

    const previousSelectedMonth = this.selectedMonth;
    this.selectedYear = startingDate.year();
    this.generateMonthNames(this.selectedYear);
    if (this.months && startingDate.month() >= 0 && startingDate.month() < this.months.length) {
      this.selectedMonth = this.months[startingDate.month()]?.gregorian;
    } else {
      console.error('Invalid month index or months array is not defined');
      this.selectedMonth = 'Unknown';
    }
    if (this.selectedMonth !== previousSelectedMonth) {
      this.selectedDay = null;
    }
    this.selectedDay = filledDateMoment ? filledDateMoment.date() : this.selectedDay;
    const startingHijriDate = startingDate.clone().locale('en');
    this.selectedHijriYear = startingHijriDate.iYear();
    this.selectedHijriMonth = startingHijriDate.format('iMMMM');
    if (
      this.selectedYear === this.minDate.year &&
      this.months.findIndex((month) => month.gregorian === this.selectedMonth) === this.minDate.month
    ) {
      this.commonObj.headPrevDisabled = true;
    } else {
      this.commonObj.headPrevDisabled = false;
    }

    if (
      this.selectedYear === this.maxDate.year &&
      this.months.findIndex((month) => month.gregorian === this.selectedMonth) === this.maxDate.month
    ) {
      this.commonObj.headNextDisabled = true;
    } else {
      this.commonObj.headNextDisabled = false;
    }
    this.showCalendar = true;
    this.showMonths = false;
    this.autoGeneratedDays = this.daysInMonth();
  }

  setMinDateRange() {
    let departureDate = new Date(this.departureDate);
    let year = departureDate.getFullYear();
    let month = departureDate.getMonth();
    let date = departureDate.getDate();
    this.minDate = { year, month, date };
  }

  setMaxDateRange() {
    let minDate = new Date(this.minDate.year, this.minDate.month, this.minDate.date);
    if (
      this.passengerTravelerCode === 'INF' ||
      this.passengerTravelerCode === 'INS' ||
      this.passengerTravelerCode === 'CHD' ||
      this.infantTravelerCode === 'INF'
    ) {
      minDate.setFullYear(minDate.getFullYear() + 47);
    } else if (
      this.passengerTravelerCode === 'ADT'
    ) {
      minDate.setFullYear(minDate.getFullYear() + 20);
    }
    let year = minDate.getFullYear();
    let month = minDate.getMonth();
    let date = minDate.getDate();
    this.maxDate = { year, month, date };
  }


  generateYearRange(): void {

    this.visibilityService.getCurrentExpCalenderStatus().subscribe(($calendarStatus: any) => {
      if (!!$calendarStatus) {
        this.isHijri = $calendarStatus.hijri;
      }
    });

    this.setMinDateRange();
    this.setMaxDateRange();

    const currentYear = moment().year();
    const departureYear = moment(this.departureDate).year();
    const minYear = this.minDate.year;
    const maxYear = this.maxDate.year;
    if (!this.currentRangeStart || this.currentRangeStart < minYear || this.currentRangeStart > maxYear) {
      this.currentRangeStart = Math.max(minYear, departureYear - 13);
    }

    const rangeEnd = Math.min(this.currentRangeStart + this.rangeStep - 1, maxYear);
    const yearPairs: { gregorian: number; hijri: number; disabled: boolean }[] = [];
    for (let year = this.currentRangeStart; year <= rangeEnd; year++) {
      const gregorianYear = year;
      const hijriYear = this.getHijriYear(`${gregorianYear}-01-01`);
      const isDisabled = year < departureYear || year < minYear;
      yearPairs.push({ gregorian: gregorianYear, hijri: hijriYear, disabled: isDisabled });
    }

    this.years = yearPairs;
    this.commonObj.headPrevDisabled = this.currentRangeStart <= minYear;
    this.commonObj.headNextDisabled = rangeEnd >= maxYear;
  }

  nextRange(): void {
    const maxYear = this.maxDate.year;

    if (this.currentRangeStart + this.rangeStep <= maxYear) {
      this.currentRangeStart += this.rangeStep;
      this.generateYearRange();
    } else {
      this.commonObj.headNextDisabled = true;
    }
  }

  previousRange(): void {
    const minYear = this.minDate.year;

    if (this.currentRangeStart - this.rangeStep >= minYear) {
      this.currentRangeStart -= this.rangeStep;
      this.generateYearRange();
    } else {
      this.commonObj.headPrevDisabled = true;
    }
  }








  calculateAgeFromCurrentDate(): number | null {
    const currentDate = moment();

    if (!this.selectedYear) {
      console.error("Selected year is null or undefined!");
      return null;
    }
    return currentDate.year() - this.selectedYear;
  }
  gregorianMonths: any[] = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  generateMonthNames(selectedYear: number): void {
    const hijriMonths: string[] = [];
    for (let i = 0; i < 12; i++) {
      const gregorianDate = moment(`${selectedYear}-01-01`, 'YYYY-MM-DD').add(i, 'months');
      const hijriMonth = gregorianDate.format('iMMM');
      hijriMonths.push(hijriMonth);
    }
    this.months = this.gregorianMonths.map((gregorianMonth, index) => ({
      gregorian: gregorianMonth,
      hijri: hijriMonths[index],
      disabled:
        (this.minDate.year === selectedYear && this.minDate.month > index) || // Disable months before minDate
        (this.maxDate.year === selectedYear && this.maxDate.month < index)    // Disable months after maxDate
    }));
  }
  getHijriYear(gregorianDate: string): number {
    const date = moment(gregorianDate, 'YYYY-MM-DD');
    return date.iYear();
  }

  selectYear(year: number): void {
    this.commonObj.headPrevDisabled = false;
    this.commonObj.headNextDisabled = false;
    this.selectedYear = year;
    const hijriDate = moment(`${year}-01-01`, 'YYYY-MM-DD');
    this.selectedHijriYear = hijriDate.iYear();
    this.generateMonthNames(year);
    this.showMonths = true;
    this.showCalendar = false;
    if (this.selectedYear === this.minDate.year) {
      this.commonObj.headPrevDisabled = true;
    }
    if (this.selectedYear === this.maxDate.year) {
      this.commonObj.headNextDisabled = true;
    }
    this.cdr.detectChanges();
  }
  selectMonth(month: string): void {
    this.commonObj.headPrevDisabled = false;
    this.commonObj.headNextDisabled = false;
    this.selectedMonth = month;
    if (this.isHijri) {
      const monthIndex = this.months.findIndex((m) => m.gregorian === month);
      if (monthIndex !== -1) {
        const hijriMonthName = moment(`${this.selectedYear}-${monthIndex + 1}-01`, 'YYYY-MM-DD').format('iMMMM'); // Get Hijri month name
        this.selectedHijriMonth = hijriMonthName;
      } else {
        console.error('Invalid month selected:', month);
      }
    }
    if (this.selectedYear === this.minDate.year && this.months.findIndex(month => month.gregorian === this.selectedMonth) === this.minDate.month) {
      this.commonObj.headPrevDisabled = true;
    }
    if (this.selectedYear === this.maxDate.year && this.months.findIndex(month => month.gregorian === this.selectedMonth) === this.maxDate.month) {
      this.commonObj.headNextDisabled = true;
    }

    this.autoGeneratedDays = this.daysInMonth();
    this.showCalendar = true;
    this.showMonths = false;
  }



  selectDay(day: number): void {
    this.selectedDay = day;
    const monthIndex = this.months.findIndex(month => month.gregorian === this.selectedMonth);
    if (monthIndex === -1) {
      console.error("Invalid month selected.");
      return;
    }
    this.fetchSelectedDate[1] = monthIndex + 1;
    this.fetchSelectedDate[2] = this.selectedYear;
    this.selectedDate = new Date(this.selectedYear, monthIndex, day);
  }
  previousMonthRange(): void {
    if (this.selectedYear !== null) {
      if (this.selectedYear <= this.minDate.year) {
        this.commonObj.headPrevDisabled = true;
        return;
      }
      this.selectedYear -= 1;
      this.selectedHijriYear -= 1;
      this.generateMonthNames(this.selectedYear);
      this.selectedMonth = this.months[11].gregorian;
      this.showCalendar = false;
      this.showMonths = true;
    }

  }
  nextMonthRange(): void {
    this.commonObj.headPrevDisabled = false
    if (this.selectedYear >= this.maxDate.year) {
      return;
    }
    if (this.selectedYear !== null) {
      this.maxYearRange = Math.max(...this.years.map(item => item.gregorian));
      this.selectedYear += 1;
      this.selectedHijriYear += 1;
      this.generateMonthNames(this.selectedYear);
      this.selectedMonth = this.months[0].gregorian;
      this.showCalendar = false;
      this.showMonths = true;
    }
  }
  previousDayRange(): void {
    if (this.selectedMonth) {
      const currentIndex = this.months.findIndex(month => month.gregorian === this.selectedMonth);
      this.commonObj.headNextDisabled = false;
      if (this.selectedYear === this.minDate.year && currentIndex === this.minDate.month) {
        this.commonObj.headPrevDisabled = true;
        return;
      }
      if (currentIndex === 0) {
        const gregorianDate = moment(`${this.selectedYear}-01-01`, 'YYYY-MM-DD').subtract(1, 'month');
        this.selectedMonth = this.months[11].gregorian;
        this.selectedYear = gregorianDate.year();
        this.selectedHijriYear = gregorianDate.iYear();
        this.selectedHijriMonth = gregorianDate.format('iMMMM');
      } else {
        const gregorianDate = moment(`${this.selectedYear}-${currentIndex + 1}-01`, 'YYYY-MM-DD').subtract(1, 'month');
        this.selectedMonth = this.months[currentIndex - 1].gregorian;
        this.selectedHijriYear = gregorianDate.iYear();
        this.selectedHijriMonth = gregorianDate.format('iMMMM');
      }
      if (this.selectedYear === this.minDate.year && this.months.findIndex(month => month.gregorian === this.selectedMonth) === this.minDate.month) {
        this.commonObj.headPrevDisabled = true;
      } else {
        this.commonObj.headPrevDisabled = false;
      }
      this.autoGeneratedDays = this.daysInMonth();
      this.showCalendar = true;
    }
  }

  nextDayRange(): void {
    if (this.selectedMonth) {
      const currentIndex = this.months.findIndex(month => month.gregorian === this.selectedMonth);
      if (this.selectedYear === this.maxDate.year) {
        if (currentIndex >= this.maxDate.month) {
          this.commonObj.headNextDisabled = true;
          return;
        }
      }
      this.commonObj.headPrevDisabled = false;
      if (currentIndex === 11) {
        this.selectedMonth = this.months[0].gregorian;
        this.selectedYear = (this.selectedYear ?? new Date().getFullYear()) + 1;
      } else {
        this.selectedMonth = this.months[currentIndex + 1].gregorian;
      }
      if (this.selectedYear > this.maxDate.year || (this.selectedYear === this.maxDate.year && currentIndex + 1 > this.maxDate.month)) {
        this.commonObj.headNextDisabled = true;
        return;
      }
      const gregorianDate = moment(`${this.selectedYear}-${currentIndex + 2}-01`, 'YYYY-MM-DD'); // +2 because months are 0-based in moment
      this.selectedHijriYear = gregorianDate.iYear();
      this.selectedHijriMonth = gregorianDate.format('iMMMM');


      if (this.selectedYear === this.maxDate.year && this.months.findIndex(month => month.gregorian === this.selectedMonth) === this.maxDate.month) {
        this.commonObj.headNextDisabled = true;
      } else {
        this.commonObj.headNextDisabled = false;
      }
      this.autoGeneratedDays = this.daysInMonth();
      this.showCalendar = true;
    }
  }
  openLastMonthOfYear(): void {
    if (this.selectedYear !== null) {
      if (this.selectedYear === this.maxDate.year) {
        const maxDateMonthIndex = this.maxDate.month;
        this.selectedMonth = this.months[maxDateMonthIndex]?.gregorian || 'Dec';
      } else {
        this.selectedMonth = 'Dec';
      }
      this.showCalendar = true;
      this.showMonths = false;
    }
  }
  daysInMonth(): Array<{ day: number | null; hijri: string | null, disabled: boolean }> {
    if (this.selectedYear !== null && this.selectedMonth !== null) {
      const monthIndex = this.months.findIndex(month => month.gregorian === this.selectedMonth);
      const firstDay = new Date(this.selectedYear, monthIndex, 0).getDay();
      const daysInMonth = new Date(this.selectedYear, monthIndex + 1, 0).getDate();
      const days: Array<{ day: number | null; hijri: string | null, disabled: boolean }> = [];
      const today = moment();
      const todayDay = today.date();
      const todayMonth = today.month();
      const todayYear = today.year();
      for (let i = 0; i < firstDay; i++) {
        days.push({ day: null, hijri: null, disabled: false });
      }
      for (let i = 1; i <= daysInMonth; i++) {
        const gregorianDate = moment(`${this.selectedYear}-${monthIndex + 1}-${i}`, 'YYYY-MM-DD');
        const hijriDate = this.isHijri ? gregorianDate.format('iD') : '';
        const isBeforeMinDate =
          this.minDate &&
          (this.selectedYear < this.minDate.year ||
            (this.selectedYear === this.minDate.year && monthIndex < this.minDate.month) ||
            (this.selectedYear === this.minDate.year && monthIndex === this.minDate.month && i < this.minDate.date));

        const isAfterMaxDate =
          this.maxDate &&
          (this.selectedYear > this.maxDate.year ||
            (this.selectedYear === this.maxDate.year && monthIndex > this.maxDate.month) ||
            (this.selectedYear === this.maxDate.year && monthIndex === this.maxDate.month && i > this.maxDate.date));
        days.push({
          day: i,
          hijri: hijriDate,
          disabled: isBeforeMinDate || isAfterMaxDate
        });
      }
      return days;
    }
    return [];
  }
  onYearRangeClick(): void {
    this.commonObj.headPrevDisabled = false;
    this.commonObj.headNextDisabled = false;
    this.selectedYear = this.maxDate.year;
    const hijriYear = moment(`${this.selectedYear}-01-01`, 'YYYY-MM-DD').iYear();
    this.generateMonthNames(this.selectedYear);
    this.selectedMonth = this.months[this.maxDate.month]?.gregorian;
    if (this.isHijri) {
      const hijriMonthName = moment(`${this.selectedYear}-${this.maxDate.month + 1}-01`, 'YYYY-MM-DD').format('iMMMM');
      this.selectedHijriMonth = hijriMonthName;
    }
    if (!this.selectedMonth) {
      console.error('Failed to set the selected month. Ensure months are generated correctly.');
      return;
    }
    this.selectedHijriYear = hijriYear;
    this.showMonths = false;
    this.showCalendar = true;
    if (this.selectedYear === this.maxDate.year && this.months.findIndex(month => month.gregorian === this.selectedMonth) === this.maxDate.month) {
      this.commonObj.headNextDisabled = true;
    }
  }
  backToYearRange(): void {
    this.showMonths = false;
    this.showCalendar = false;
    this.generateYearRange();
  }
  toggleCalendar() {
    this.isHijri = !this.isHijri;
    this.visibilityService.setCurrentExpCalenderStatus({ hijri: this.isHijri });
    this.autoGeneratedDays = this.daysInMonth();
  }
  confirmSelection() {
    this.dateSelected.emit({ type: 'dob', date: this.selectedDate });
    this.visibilityService.setVisibility(!!this.key ? this.key : 'isVisibleCalendar', false); 
       // Hide component
  }
  isDisabledYearExits(): boolean {
    return !!this.years.filter(($year: any) => !!$year.disabled).length;
  }
  getCalendarStatus(day: any): boolean {
    if (!!this.selectedMonth) {
      this.selectedMonthIndex = this.gregorianMonths.findIndex(($: string, $i: number) => $ == this.selectedMonth) + 1;
    }
    return (day.day === this.selectedDay && this.selectedMonthIndex == this.fetchSelectedDate[1] && this.selectedYear == this.fetchSelectedDate[2])
  }
}
